ixModuleRouting("impactx.search", {
    "/search": {
        template: "<ixa-search-overview></ixa-search-overview>",
        templateUrl: "modules/search/templates/search.html",
        controller: "SearchOverviewCtrl",
        controllerAs: "searchCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search/themeworld/:themeworldId": {
        template: "<ixa-search-overview></ixa-search-overview>",
        templateUrl: "modules/search/templates/search.html",
        controller: "SearchOverviewCtrl",
        controllerAs: "searchCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.all/:optionalId?": {
        template: "<ixa-search-list-all></ixa-search-list-all>",
        templateUrl: "modules/search/templates/search.all.html",
        controller: "SearchListCtrl",
        controllerAs: "proListCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.tender/:lotId?/:supplierId?/:useSetFilterList?": {
        template: "<ixa-search-list-tender></ixa-search-list-tender>",
        templateUrl: "modules/search/templates/search.tender.html",
        controller: "SearchListTenderCtrl",
        controllerAs: "searchListTenderCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.lot/:tenderId?/:catalogId?/:supplierId?/:useSetFilterList?": {
        template: "<ixa-search-list-lot></ixa-search-list-lot>",
        templateUrl: "modules/search/templates/search.lot.html",
        controller: "SearchListLotCtrl",
        controllerAs: "searchListLotCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.catalog/:tenderId?/:lotId?/:supplierId?/:sortByName?/:useSetFilterList?": {
        template: "<ixa-search-list-catalog></ixa-search-list-catalog>",
        templateUrl: "modules/search/templates/search.catalog.html",
        controller: "SearchListCatalogCtrl",
        controllerAs: "searchListCatalogCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.product": {
        template: "<ixa-search-list-product-infinite></ixa-search-list-product-infinite>",
        templateUrl: "modules/search/templates/search.product.infinite.html",
        controller: "SearchListProductInfiniteCtrl",
        controllerAs: "proListCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.product/:nosearch": {
        template: "<ixa-search-list-product-infinite></ixa-search-list-product-infinite>",
        templateUrl: "modules/search/templates/search.product.infinite.html",
        controller: "SearchListProductInfiniteCtrl",
        controllerAs: "proListCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.supplier/:tenderId?/:lotId?/:useSetFilterList?": {
        template: "<ixa-search-list-supplier></ixa-search-list-supplier>",
        templateUrl: "modules/search/templates/search.supplier.html",
        controller: "SearchListSupplierCtrl",
        controllerAs: "searchListSupplierCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.tender.preset": {
        template: "<ixa-search-list-tender-preset></ixa-search-list-tender-preset>",
        templateUrl: "modules/search/templates/search.tender.html",
        controller: "SearchListTenderPreSetCtrl",
        controllerAs: "searchListTenderCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.lot.preset": {
        template: "<ixa-search-list-lot-preset></ixa-search-list-lot-preset>",
        templateUrl: "modules/search/templates/search.lot.html",
        controller: "SearchListLotPreSetCtrl",
        controllerAs: "searchListLotCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.catalog.preset": {
        template: "<ixa-search-list-catalog-preset></ixa-search-list-catalog-preset>",
        templateUrl: "modules/search/templates/search.catalog.html",
        controller: "SearchListCatalogPreSetCtrl",
        controllerAs: "searchListCatalogCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.supplier.preset": {
        template: "<ixa-search-list-supplier-preset></ixa-search-list-supplier-preset>",
        templateUrl: "modules/search/templates/search.supplier.html",
        controller: "SearchListSupplierPreSetCtrl",
        controllerAs: "searchListSupplierCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.manufacturer/:useSetFilter?": {
        template: "<ixa-search-list-manufacturer></ixa-search-list-manufacturer>",
        templateUrl: "modules/search/templates/search.manufacturer.html",
        controller: "SearchListManufacturerCtrl",
        controllerAs: "searchListManufacturerCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.product/tender/:tenderId": {
        template: "<ixa-search-list-product-infinite></ixa-search-list-product-infinite>",
        templateUrl: "modules/search/templates/search.product.infinite.html",
        controller: "SearchListProductInfiniteCtrl",
        controllerAs: "proListCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.product/lot/:lotId": {
        template: "<ixa-search-list-product-infinite></ixa-search-list-product-infinite>",
        templateUrl: "modules/search/templates/search.product.infinite.html",
        controller: "SearchListProductInfiniteCtrl",
        controllerAs: "proListCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.product/vcat/:vcatId": {
        template: "<ixa-search-list-product-infinite></ixa-search-list-product-infinite>",
        templateUrl: "modules/search/templates/search.product.infinite.html",
        controller: "SearchListProductInfiniteCtrl",
        controllerAs: "proListCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.product/supplier/:supplierId": {
        template: "<ixa-search-list-product-infinite></ixa-search-list-product-infinite>",
        templateUrl: "modules/search/templates/search.product.infinite.html",
        controller: "SearchListProductInfiniteCtrl",
        controllerAs: "proListCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.product/manufacturer/:manufacturerId": {
        template: "<ixa-search-list-product-infinite></ixa-search-list-product-infinite>",
        templateUrl: "modules/search/templates/search.product.infinite.html",
        controller: "SearchListProductInfiniteCtrl",
        controllerAs: "proListCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.themeworld": {
        template: "<ixa-search-list-themeworld></ixa-search-list-themeworld>",
        templateUrl: "modules/search/templates/search.themeworlds.html",
        controller: "SearchListThemeWorldCtrl",
        controllerAs: "searchListThemeWorldCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.contact/:objectName/:objectId": {
        template: "<ixa-search-list-contact></ixa-search-list-contact>",
        templateUrl: "modules/search/templates/search.contacts.html",
        controller: "SearchListContactCtrl",
        controllerAs: "searchListContactCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/search.productgroup/:id/:prgId": {
        template: "<ixa-search-list-productgroup></ixa-search-list-productgroup>",
        templateUrl: "modules/search/templates/search.productgroups.html",
        controller: "SearchListProductGroupCtrl",
        controllerAs: "searchListProductGroupCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/metaprg/:prgId": {
        template:'<ixa-meta-product-group></ixa-meta-product-group>',
        templateUrl: "modules/search/templates/metaprg.tmpl.html",
        controller: "MetaProductGroupCtrl",
        controllerAs: "metaProductGroupCtrl",
        workspace: "shop",
    },
});
